//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const';

export default {
  data() {
    return {
      model: {
        takerPayIn: 0,
        takerPayOut: 0,
        makerPayIn: 0,
        makerPayOut: 0,
      },
      setting: {
        payInRsgTime: 0,
        payInExpirationTime: 0,
        payInArbitratorCallTime: 0,
        payOutRsgTime: 0,
        payOutExpirationTime: 0,
        payOutArbitratorCallTime: 0,
      },
      tab: null,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('tradersFees', {
      feesData: 'data',
    }),
    ...mapState('tradersTimersSettings', {
      timersData: 'data',
    }),

    isTimerButtonDisabled() {
      return Object.values(this.setting).every((val) => val && val > 0);
    },
  },

  watch: {
    feesData() {
      const {
        takerPayIn,
        takerPayOut,
        makerPayIn,
        makerPayOut,
      } = this.feesData;

      this.model.takerPayIn = takerPayIn;
      this.model.takerPayOut = takerPayOut;
      this.model.makerPayIn = makerPayIn;
      this.model.makerPayOut = makerPayOut;
    },
    timersData() {
      const {
        payInRsgTime,
        payInExpirationTime,
        payInArbitratorCallTime,
        payOutRsgTime,
        payOutExpirationTime,
        payOutArbitratorCallTime,
      } = this.timersData;

      this.setting.payInRsgTime = payInRsgTime;
      this.setting.payInExpirationTime = payInExpirationTime;
      this.setting.payInArbitratorCallTime = payInArbitratorCallTime;
      this.setting.payOutRsgTime = payOutRsgTime;
      this.setting.payOutExpirationTime = payOutExpirationTime;
      this.setting.payOutArbitratorCallTime = payOutArbitratorCallTime;
    },
  },

  methods: {
    ...mapActions('common', [
      'confirmAction',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('tradersFees', {
      loadFeesData: 'loadData',
      editFees: 'editFees',
    }),
    ...mapActions('tradersTimersSettings', {
      loadTimersSettings: 'loadData',
      updateTimersSettings: 'updateTimersSettings',
    }),

    apply() {
      this.confirmAction({
        title: 'Are you sure you want to update fees?',
        callback: async () => {
          const {
            takerPayIn,
            takerPayOut,
            makerPayIn,
            makerPayOut,
          } = this.model;
          this.setGeneralProgress(true);
          try {
            await this.editFees({
              takerPayIn,
              takerPayOut,
              makerPayIn,
              makerPayOut,
            });
            this.setSuccessNotification('Fees updated successfully');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          await this.loadFeesData();
          this.setGeneralProgress(false);
        },
      });
    },

    applyTimers() {
      this.confirmAction({
        title: 'Are you sure you want to update timings settings?',
        callback: async () => {
          this.setGeneralProgress(true);
          try {
            await this.updateTimersSettings({ setting: this.setting });
            this.setSuccessNotification('Timings settings updated successfully');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          await this.loadTimersSettings();
          this.setGeneralProgress(false);
        },
      });
    },
  },
};
